/* Ayudate · Validaciones con mensaje explícito */


/* En vez de "campo inválido", cada función dice exactamente qué falta. */

export const vNombre = (v) => {
  const t = (v || "").trim();
  if (!t) return "Escriba su nombre completo.";
  if (/[^A-Za-zÀ-ÿ\s']/.test(t)) return "No se permiten caracteres especiales, guiones ni números.";
  const partes = t.replace(/\s+/g, " ").split(" ").filter((x) => x.length > 1);
  if (partes.length < 2) return "Muy corto: escriba su nombre y su apellido.";
  return "";
};

/* A los tutores se les pide como mínimo un apellido: alcanza para ubicar
   a alguien que solo tiene un apellido registrado. */
export const vNombreCompleto = (v) => {
  const t = (v || "").trim().replace(/\s+/g, " ");
  if (!t) return "Escriba su nombre completo.";
  if (/[^A-Za-zÀ-ÿ\s']/.test(t)) return "No se permiten caracteres especiales, guiones ni números.";
  const partes = t.split(" ").filter((x) => x.length > 1);
  if (partes.length < 1) return "Escriba al menos su apellido.";
  return "";
};

export const vCorreo = (v) => {
  const t = (v || "").trim();
  if (!t) return "Escriba su correo.";
  if (!t.includes("@")) return "Falta el @. Por ejemplo: nombre@dominio";
  const [ini, dom] = t.split("@");
  if (!ini) return "Falta lo que va antes del @.";
  if (!dom) return "Falta el dominio después del @. Por ejemplo: dominio.com";
  if (!/\.[a-z]{2,}$/i.test(dom)) return "Al dominio le falta la terminación. Por ejemplo: .cr o .com";
  if (/\s/.test(t)) return "El correo no lleva espacios.";
  return "";
};

/* El código de país va aparte (ver TelefonoInput). El campo de número deja
   escribir cualquier carácter para poder avisar al toque si algo no es un
   dígito, en vez de borrarlo en silencio. */
export const vTelefono = (v) => {
  const t = (v || "").trim();
  if (!t) return "Escriba su número de teléfono.";
  if (/\D/.test(t)) return "Solo se permiten números, sin espacios, letras ni símbolos.";
  if (t.length < 7) {
    const f = 7 - t.length;
    return `${f === 1 ? "Falta 1 dígito" : `Faltan ${f} dígitos`}: lleva ${t.length}.`;
  }
  if (t.length > 11) return "Máximo 11 dígitos.";
  return "";
};

export const vCarrera = (v) => {
  const t = (v || "").trim();
  if (!t) return "Escriba su carrera.";
  if (/[^A-Za-zÀ-ÿ\s'-]/.test(t)) return "No se permiten caracteres especiales.";
  if (t.length < 3) return "Escriba su carrera completa.";
  return "";
};

export const vAnio = (v) => ((v || "").trim() ? "" : "Elija su año en curso.");

export const vCurso = (v) =>
  /[^A-Za-zÀ-ÿ0-9\s]/.test(v || "") ? "No se permiten caracteres especiales." : "";

/* Quita etiquetas HTML y los caracteres típicos de una inyección de script
   (< > ` { } ; =), sin tocar acentos ni otros idiomas. Se usa antes de guardar
   o filtrar con cualquier texto que escribe la persona usuaria. */
export const sanitizarTexto = (v) => (v || "")
  .replace(/<[^>]*>/g, "")
  .replace(/[<>`{};=]/g, "")
  .trim();

export const vUsuario = (v) => ((v || "").trim() ? "" : "Elija un usuario.");

export const vPassword = (v) => {
  if (!v) return "Elija una contraseña.";
  if (v.length < 8) return "Mínimo 8 caracteres.";
  return "";
};

export const vTexto = (v, min, vacio) => {
  const t = (v || "").trim();
  if (!t) return vacio;
  if (t.length < min) {
    const f = min - t.length;
    return `${f === 1 ? "Le falta 1 carácter" : `Le faltan ${f} caracteres`}: lleva ${t.length} de ${min}.`;
  }
  return "";
};
